<style>
  #fotarda {
    width: 50px;
    vertical-align: middle !important;
    border-style: none !important;
    float: none !important;
}
</style>
<template>
  <b-card body-class="p-0" header-class="border-0">
    <template v-slot:header>
  <b-row align-v="center">
    <b-col cols="12" md="4">
      <h3 class="mb-0">Información Completa</h3>
    </b-col>
    <b-col cols="12" md="2" >
      <button class="btn btn-primary" @click="exportToExcel">Exportar a Excel</button>
      </b-col>
    <b-col cols="12" md="3" class="text-right">
      <el-input v-model="filtroTicket" type="number" placeholder="Filtrar por ticket"></el-input>
    </b-col>
    <b-col cols="12" md="3">
      <el-select v-model="filtroDestino" placeholder="Filtrar por destino">
  <el-option label="Todos los destinos" value=""></el-option>
  <el-option
    v-for="destino in destinosUnicos"
    :key="destino"
    :label="destino"
    :value="destino">
  </el-option>
</el-select>

    </b-col>
  </b-row>
</template>


    <template v-if="!loading">
  <el-table
    class="table-responsive table"
    :data="paginatedData"
    header-row-class-name="thead-light">

              <el-table-column
            label="Jornada"
            min-width="140px">
            <template v-slot:default="{ row }">
              <div ><b>{{ row.JORNADA }}</b></div>
            </template>
          </el-table-column>

          <el-table-column
            label="Ticket"
            min-width="120px">
            <template v-slot:default="{ row }">
              <div ><b>{{ row.TICKET }}</b></div>
            </template>
          </el-table-column>

          <el-table-column
            label="Foto"
            min-width="90px">
            <template v-slot:default="{ row }">

        <div>
              <!-- Si FOTO_TICKET_ALMACEN es distinto de '0', muestra el icono de la cámara con el enlace -->
              <a v-if="row.FOTO_TICKET_MUELLE !==  0" :href="'https://www.appsheet.com/template/gettablefileurl?appName=GRANELES-4418935&tableName=DATA_GRANEL&fileName='+row.FOTO_TICKET_MUELLE" target="_blank">
                <i class="fa fa-camera fa-lg"></i>
              </a>
              <!-- Si FOTO_TICKET_ALMACEN es igual a '0', muestra un guion "-" -->
              <span v-else>-</span>
            </div>
            </template>
          </el-table-column>

          
          <el-table-column
            label="BL"
            min-width="70px">
            <template v-slot:default="{ row }">
              <div ><b>{{ row.BL }}</b></div>
            </template>
          </el-table-column>

          <el-table-column
            label="Destino"
            min-width="180px">
            <template v-slot:default="{ row }">
              <div ><b>{{ row.DESTINO }}</b></div>
            </template>
          </el-table-column>

          <el-table-column
            label="Bodega"
            min-width="160px">
            <template v-slot:default="{ row }">
              <div ><b>{{ row.BODEGA }}</b></div>
            </template>
          </el-table-column>
          
          <el-table-column
            label="Placa"
            min-width="100px">
            <template v-slot:default="{ row }">
              <div ><b>{{ row.PLACA }}</b></div>
            </template>
          </el-table-column>


          <el-table-column label="Transporte" min-width="220px">
            <template v-slot:default="{ row }">
              <el-tooltip class="item" effect="dark" :content="row.TRANSPORTE" placement="top">
                <div class="text-truncate"><b>{{ row.TRANSPORTE }}</b></div>
              </el-tooltip>
            </template>
          </el-table-column>


          <el-table-column
            label="Ingreso Balanza"
            min-width="170px">
            <template v-slot:default="{ row }">
              <div ><b>{{ row.FECHA_INGRESO_BALANZA }}</b></div>
            </template>
          </el-table-column>


          <el-table-column label="Balanza Entrada" min-width="110px">
              <template v-slot:header="{ column }">
                <el-tooltip class="item" effect="dark" :content="column.label" placement="top">
                  <span>{{ column.label }}</span>
                </el-tooltip>
              </template>
              <template v-slot:default="{ row }">
              <div ><b>{{ row.BALANZA_ENTRADA }}</b></div>
            </template>
                </el-table-column>


          <el-table-column
            label="Tiempo Antes de Carguío"
            min-width="130px">
            <template v-slot:header="{ column }">
                <el-tooltip class="item" effect="dark" :content="column.label" placement="top">
                  <span>{{ column.label }}</span>
                </el-tooltip>
              </template>
            <template v-slot:default="{ row }">
              <div ><b>{{ row.TIEMPO_ANTES_DE_CARGIO }}</b></div>
            </template>
          </el-table-column>

          <el-table-column
            label="Inicio de Carguío"
            min-width="170px">
            <template v-slot:default="{ row }">
              <div ><b>{{ row.FECHA_INICIO_CARGUIO }}</b></div>
            </template>
          </el-table-column>

          <el-table-column
            label="Fin de Carguío"
            min-width="170px">
            <template v-slot:default="{ row }">
              <div ><b>{{ row.FECHA_FIN_CARGIO }}</b></div>
            </template>
          </el-table-column>

          <el-table-column
            label="Tiempo de Carguío"
            min-width="130px">
            <template v-slot:header="{ column }">
                <el-tooltip class="item" effect="dark" :content="column.label" placement="top">
                  <span>{{ column.label }}</span>
                </el-tooltip>
              </template>
            <template v-slot:default="{ row }">
              <div ><b>{{ row.TIEMPO_CARGIO }}</b></div>
            </template>
          </el-table-column>
          

          <el-table-column
            label="Guía"
            min-width="100px">
            <template v-slot:default="{ row }">
              <div ><b>{{ row.GUIA }}</b></div>
            </template>
          </el-table-column>

          <el-table-column
            label="Balanza"
            min-width="110px">
            <template v-slot:default="{ row }">
             <div>
              <!-- Si FOTO_TICKET_ALMACEN es distinto de '0', muestra el icono de la cámara con el enlace -->
              <a v-if="row.FOTOS1_TICKET_BALANZA !==  0" :href="'https://www.appsheet.com/template/gettablefileurl?appName=GRANELES-4418935&tableName=DATA_GRANEL&fileName='+row.FOTOS1_TICKET_BALANZA" target="_blank">
                <i class="fa fa-camera fa-lg"></i>
              </a>
              <!-- Si FOTO_TICKET_ALMACEN es igual a '0', muestra un guion "-" -->
              <span v-else>-</span>
            </div>
            </template>
          </el-table-column>

          <el-table-column
            label="Precinto"
            min-width="110px">
            <template v-slot:default="{ row }">
              <div ><b>{{ row.PRECINTO }}</b></div>
            </template>
          </el-table-column>

          <el-table-column
            label="Permiso"
            min-width="110px">
            <template v-slot:default="{ row }">
              <div ><b>{{ row.PERMISO }}</b></div>
            </template>
          </el-table-column>

          <el-table-column
            label="Fecha Salida Balanza"
            min-width="170px">
            <template v-slot:header="{ column }">
                <el-tooltip class="item" effect="dark" :content="column.label" placement="top">
                  <span>{{ column.label }}</span>
                </el-tooltip>
              </template>
            <template v-slot:default="{ row }">
              <div ><b>{{ row.FECHA_SALIDA_BALANZA }}</b></div>
            </template>
          </el-table-column>

          <el-table-column
            label="Balanza Salida"
            min-width="90px">
            <template v-slot:header="{ column }">
                <el-tooltip class="item" effect="dark" :content="column.label" placement="top">
                  <span>{{ column.label }}</span>
                </el-tooltip>
              </template>
            <template v-slot:default="{ row }">
              <div ><b>{{ row.BALANZA_SALIDA }}</b></div>
            </template>
          </el-table-column>

          <el-table-column
            label="Demora Término de Carguío y Salida"
            min-width="130px">
            <template v-slot:header="{ column }">
                <el-tooltip class="item" effect="dark" :content="column.label" placement="top">
                  <span>{{ column.label }}</span>
                </el-tooltip>
              </template>
            <template v-slot:default="{ row }">
              <div ><b>{{ row.TIEMPO_FIN_CARG_SALIDA_BALANZA }}</b></div>
            </template>
          </el-table-column>

          <el-table-column
            label="Peso Bruto Puerto"
            min-width="130px">
            <template v-slot:header="{ column }">
                <el-tooltip class="item" effect="dark" :content="column.label" placement="top">
                  <span>{{ column.label }}</span>
                </el-tooltip>
              </template>
            <template v-slot:default="{ row }">
              <div ><b>{{ row.PESO_BRUTO_PUERTO }} TM</b></div>
            </template>
          </el-table-column>

          <el-table-column
            label="Peso Neto Puerto"
            min-width="130px">
            <template v-slot:header="{ column }">
                <el-tooltip class="item" effect="dark" :content="column.label" placement="top">
                  <span>{{ column.label }}</span>
                </el-tooltip>
              </template>
            <template v-slot:default="{ row }">
              <div ><b>{{ row.PESO_NETO_PUERTO }} TM</b></div>
            </template>
          </el-table-column>

          <el-table-column
            label="Peso Tara Puerto"
            min-width="130px">
            <template v-slot:header="{ column }">
                <el-tooltip class="item" effect="dark" :content="column.label" placement="top">
                  <span>{{ column.label }}</span>
                </el-tooltip>
              </template>
            <template v-slot:default="{ row }">
              <div ><b>{{ row.PESO_TARA_PUERTO }} TM</b></div>
            </template>
          </el-table-column>

          <el-table-column label="Almacén" min-width="110px">
          <template v-slot:default="{ row }">
            <div>
              <!-- Si FOTO_TICKET_ALMACEN es distinto de '0', muestra el icono de la cámara con el enlace -->
              <a v-if="row.FOTO_TICKET_ALMACEN !==  0" :href="'https://www.appsheet.com/template/gettablefileurl?appName=GRANELES-4418935&tableName=DATA_GRANEL&fileName='+row.FOTO_TICKET_ALMACEN" target="_blank">
                <i class="fa fa-camera fa-lg"></i>
              </a>
              <!-- Si FOTO_TICKET_ALMACEN es igual a '0', muestra un guion "-" -->
              <span v-else>-</span>
            </div>
          </template>
        </el-table-column>

          <el-table-column
            label="Ingreso Almacén"
            min-width="170px">
            <template v-slot:default="{ row }">
              <div ><b>{{ row.FECHA_INGRESO_ALMACEN }}</b></div>
            </template>
          </el-table-column>

          <el-table-column
            label="Salida Almacén"
            min-width="170px">
            <template v-slot:default="{ row }">
              <div ><b>{{ row.FECHA_SALIDA_ALMACEN }}</b></div>
            </template>
          </el-table-column>

          <el-table-column
            label="Peso Bruto Almacén"
            min-width="130px">
            <template v-slot:header="{ column }">
                <el-tooltip class="item" effect="dark" :content="column.label" placement="top">
                  <span>{{ column.label }}</span>
                </el-tooltip>
              </template>
            <template v-slot:default="{ row }">
              <div ><b>{{ row.PESO_BRUTO_ALMACEN }} TM</b></div>
            </template>
          </el-table-column>

          <el-table-column
            label="Peso Neto Almacén"
            min-width="130px">
            <template v-slot:header="{ column }">
                <el-tooltip class="item" effect="dark" :content="column.label" placement="top">
                  <span>{{ column.label }}</span>
                </el-tooltip>
              </template>
            <template v-slot:default="{ row }">
              <div ><b>{{ row.PESO_NETO_ALMCEN }} TM</b></div>
            </template>
          </el-table-column>

          <el-table-column
            label="Peso Tara Almacén"
            min-width="130px">
            <template v-slot:header="{ column }">
                <el-tooltip class="item" effect="dark" :content="column.label" placement="top">
                  <span>{{ column.label }}</span>
                </el-tooltip>
              </template>
            <template v-slot:default="{ row }">
              <div ><b>{{ row.PESO_TARA_ALMACEN }} TM</b></div>
            </template>
          </el-table-column>

          <el-table-column
            label="Diferencia Balanza/Almacén"
            min-width="130px">
            <template v-slot:header="{ column }">
                <el-tooltip class="item" effect="dark" :content="column.label" placement="top">
                  <span>{{ column.label }}</span>
                </el-tooltip>
              </template>
            <template v-slot:default="{ row }">
              <div ><b>{{ row.DIFERENCIA_PESO_BALANZA_ALMACEN }} TM</b></div>
            </template>
          </el-table-column>

    </el-table>
      <el-pagination
    @current-change="handleCurrentChange"
    :current-page="currentPage"
    :page-size="pageSize"
    layout="prev, pager, next"
    :total="filteredData.length">
  </el-pagination>

</template>
<template v-else>
  <div>Loading...</div> <!-- Ajusta según necesites -->
</template>
  </b-card>
</template>
<script>
  import { Table, TableColumn, DropdownMenu, DropdownItem, Dropdown} from 'element-ui'
  import { Pagination } from 'element-ui';
  import { Select, Option } from 'element-ui';
  import * as XLSX from 'xlsx';

  export default {

    props: {
    listaDatosData: {
      type: Array,
      default: () => [],
    },
    listaDatos: {
      type: Array,
      default: () => [],
    },
    listaDatosProducto: {
      type: Array,
      default: () => [],
    },
    listaConsignave: {
      type: Array,
      default: () => [],
    },
    listaClientesNave: {
      type: Array,
      default: () => [],
    },
    DataCompleta: {
      type: Array,
      default: () => [],
    },
  },
    name: 'page-visits-table',
    components: {
      [Table.name]: Table,
      [TableColumn.name]: TableColumn,
      [Dropdown.name]: Dropdown,
      [DropdownItem.name]: DropdownItem,
      [DropdownMenu.name]: DropdownMenu,
      'el-pagination': Pagination,
      'el-select': Select,
      'el-option': Option

    },
    data() {
      return {
        loading: true, // Indicador de carga
        currentPage: 1, // Página actual
        pageSize: 10, // Tamaño de la página
        filtroTicket: '', // Propiedad para almacenar el valor del filtro
        filtroDestino: '', // Almacena el destino seleccionado

      }
    },
    created() {
        this.fetchData(); // Asegúrate de llamar a tu método de carga de datos aquí
      },

     computed:{

      destinosUnicos() {
          // Esto asume que DataCompleta es tu lista de datos original
          const destinos = this.DataCompleta.map(row => row.DESTINO);
          // Filtra los duplicados
          return Array.from(new Set(destinos)).sort();
        },

                filteredData() {
          let data = this.DataCompleta;
          if (this.filtroDestino) {
            data = data.filter(row => row.DESTINO === this.filtroDestino);
          }
          // Aplica aquí otros filtros si es necesario
          return data;
        },


        paginatedData() {
          const start = (this.currentPage - 1) * this.pageSize;
          const end = start + this.pageSize;
          return this.filteredData.slice(start, end);
        },

      mappedItems() {
  if (this.listaDatos && this.listaDatosProducto && this.listaConsignave && this.listaClientesNave) {
    return this.listaDatos.map((item) => {
      this.listaDatosProducto.forEach(product => {
        if (product.ID == item.PRODUCTO)
          item.PRODUCTO = product.PRODUCTO;
      });

      this.listaConsignave.forEach(productoxd => {
        if (productoxd.ID == item.ID_CONSIGNATARIO)
          item.CONSIGNAVE = productoxd.CONSIGNATARIO;
      });

      this.listaClientesNave.forEach(clientnave => {
        if (clientnave.ID == item.CONSIGNAVE)
          item.CONSIGNAVE = clientnave.CONSIGNATARIO;
      });

      return {
        BAGS: item.BAGS,
        BLS: item.BLS,
        CANTIDAD: this.convertir(item.CANTIDAD),
        PRODUCTO: item.PRODUCTO,
        ID: item.ID,
        Consignatario: item.CONSIGNAVE,
      };
    });
  } else {
    console.error('Al menos una de las listas es undefined. Lista de datos:', this.listaDatos, 'Lista de productos:',
     this.listaDatosProducto, 'Lista de consignatarios:', this.listaConsignave, 'Lista de clientes de nave:', this.listaClientesNave);
    return [];
  }
},


     },
     methods: {

      async fetchData() {
  this.loading = true;
  try {
    const data = await myApiCall(); // Tu llamada a la API o fuente de datos
    this.myData = data; // Asegúrate de que myData es una propiedad reactiva definida en data()
    this.loading = false;
  } catch (error) {
    console.error("Error al cargar los datos:", error);
    this.loading = false;
  }
},

exportToExcel() {
    const ws = XLSX.utils.json_to_sheet(this.filteredData); // Asegúrate de que 'filteredData' es tu lista de datos filtrada
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "DatosExportados");
    XLSX.writeFile(wb, "DatosExportados.xlsx");
  },

validarFiltro() {
    this.filtroTicket = this.filtroTicket.replace(/\D/g, '');
  },

          handleSizeChange(newSize) {
        this.pageSize = newSize;
        this.currentPage = 1; // Restablecer a la primera página para evitar posibles errores de rango
        },
        handleCurrentChange(newPage) {
          this.currentPage = newPage;
        },

     convertir(item){
     if(typeof(item)==="string")
     return parseFloat(item.replace(",", "."))

     if (typeof(item)==="number")
     return parseFloat(item.toString())
 

            },

         
         }
  }
</script>
<style>

.el-input, .el-select {
  width: 100%; /* Asegura que ocupen todo el ancho de su contenedor */
}

/* Estilos adicionales para ajustar el tamaño de los elementos internos de el-select y el-input */
.el-input .el-input__inner, .el-select .el-input__inner {
  height: 40px; /* O el tamaño deseado */
  line-height: 40px; /* Ajusta esto según la altura para centrar el texto verticalmente */
}

input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Para Firefox */
input[type=number] {
  -moz-appearance: textfield;
}

.text-truncate {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.el-tooltip .el-tooltip__popper.is-dark {
  max-width: 200px; /* Ajusta según la necesidad */
  white-space: pre-wrap;
}


.custom-progress-bar.orange {
  background-color: #FF6800;
}

.custom-progress-bar.yellow {
  background-color: #FFAF1D;
}

.custom-progress-bar.green {
  background-color: #38c172;
}

</style>
